import { useEffect, useState } from 'react';

/** IntersectionObserver can be missing (old browsers, some test environments). */
export const supportsIntersectionObserver = () =>
	typeof window !== 'undefined' && typeof window.IntersectionObserver === 'function';

/**
 * Calls `onVisible` whenever the sentinel element scrolls into view inside
 * `root` (within `rootMargin` of it). Returns callback refs for both elements
 * and whether the observer is available — without it, callers render a
 * "Load more" button instead. The effect only subscribes to the observer.
 */
export const useInfiniteScrollSentinel = ({ onVisible, enabled, rootMargin = '120px' }) => {
	const [root, setRoot] = useState(null);
	const [sentinel, setSentinel] = useState(null);
	const supported = supportsIntersectionObserver();

	useEffect(() => {
		if (!supported || !enabled || !sentinel) return undefined;
		const observer = new window.IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) onVisible();
			},
			{ root, rootMargin },
		);
		observer.observe(sentinel);
		return () => observer.disconnect();
	}, [supported, enabled, sentinel, root, rootMargin, onVisible]);

	return { rootRef: setRoot, sentinelRef: setSentinel, supported };
};
